import { AnalyticsContext } from '@carvana/eventable-clickstream';
import React, { useContext } from 'react';
import ViewTracker from 'react-view-tracker';

export type TrackWrapperProps = {
  children: React.JSX.Element;
  delay?: number;
  event: {
    customAttributes?: Record<string, any>;
    eventName: string;
  };
  visiblePercentage?: number;
  trackOnce?: boolean;
  className?: string;
};

export default function TrackWrapper({
  children,
  delay = 1000,
  event: { eventName, customAttributes },
  visiblePercentage = 0.5,
  trackOnce = false,
  className = ''
}: TrackWrapperProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  const trackerFn = () => {
    trackEvent(eventName, customAttributes);
  };

  const timeoutRef = React.useRef(0);

  return (
    <div className={className}>
      <ViewTracker
        visiblePercentage={visiblePercentage}
        onShow={() => {
          timeoutRef.current = window.setTimeout(trackerFn, delay);
        }}
        onHide={() => {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = 0;
        }}
        once={trackOnce}
      >
        {children}
      </ViewTracker>
    </div>
  );
}
